var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"calc-view",attrs:{"id":"app"}},[_c('CalcMain',{staticClass:"calc-view__calc"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }